import React, { useMemo, useState } from "react";
import { matchesTokens } from "@/lib/search";

/**
 * Hook for client-side filtering over a list of rows.
 * Provides a single search box that matches any of the given field paths (using dot notation).
 *
 * Usage:
 *   const { filtered, FilterBar } = useTableFilter(rows, ["client_name", "po_number", "items.material_name"]);
 *   {FilterBar}
 *   {filtered.map(...)}
 */
export function useTableFilter(rows, fields, placeholder = "Cari…") {
  const [q, setQ] = useState("");
  const filtered = useMemo(() => {
    if (!q.trim()) return rows;
    const get = (obj, path) => {
      const parts = path.split(".");
      let v = obj;
      for (const p of parts) {
        if (v == null) return null;
        if (Array.isArray(v)) {
          return v.map((x) => x?.[p]).filter(Boolean).join(" ");
        }
        v = v[p];
      }
      return v;
    };
    // Iter v34cw (#5) — Pencarian KOMBINASI KATA: semua token harus ada pada
    // gabungan seluruh field (bukan lagi satu field harus memuat seluruh query).
    return rows.filter((r) =>
      matchesTokens(fields.map((f) => String(get(r, f) || "")).join(" \u00b7 "), q)
    );
  }, [rows, q, fields]);

  const FilterBar = (
    <div className="flex items-center gap-2 w-full sm:w-auto" data-testid="filter-bar">
      <input
        type="search"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder={placeholder}
        className="border border-stone-300 px-3 py-1.5 text-sm flex-1 sm:flex-none sm:w-64 focus:border-terra-500 focus:ring-1 focus:ring-terra-500 outline-none"
        data-testid="filter-input"
      />
      {q && (
        <button onClick={() => setQ("")} className="text-xs text-stone-500 hover:text-red-700 shrink-0">Reset</button>
      )}
      <span className="text-xs text-stone-400 ml-1 shrink-0 whitespace-nowrap">{filtered.length} / {rows.length}</span>
    </div>
  );

  return { filtered, FilterBar, q, setQ };
}
